"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColumnLayoutTitleStyled = exports.ColumnLayoutItemWrapStyled = exports.ColumnLayoutLineStyled = exports.ColumnLayoutItemStyled = exports.ColumnLayoutUiStyled = exports.ColumnLayoutAEMStyled = void 0;

var _uiKit = require("@dbi-tools/ui-kit");

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  font-size: 24px;\n  line-height: 36px;\n  font-weight: bold;\n  margin: 0 0 15px;\n  ", " {\n    font-size: 18px;\n    line-height: 27px;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  .aem-container,\n  div[data-name='container'],\n  div[data-name='container-fluid'],\n  div[class^='container-'] {\n    padding: 0;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  border-bottom: 1px solid #d8d8d8;\n  margin-top: 45px;\n  ", " {\n    margin-top: 15px;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  padding-top: 15px;\n  padding-bottom: 15px;\n  img {\n    max-width: 100%;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ColumnLayoutAEMStyled = (0, _uiKit.styled)('div')(_templateObject(), _uiKit.Colors.gray800);
exports.ColumnLayoutAEMStyled = ColumnLayoutAEMStyled;
var ColumnLayoutUiStyled = (0, _uiKit.styled)(_uiKit.Row)(_templateObject2());
exports.ColumnLayoutUiStyled = ColumnLayoutUiStyled;
var ColumnLayoutItemStyled = (0, _uiKit.styled)(_uiKit.Col)(_templateObject3());
exports.ColumnLayoutItemStyled = ColumnLayoutItemStyled;
var ColumnLayoutLineStyled = (0, _uiKit.styled)(_uiKit.Box)(_templateObject4(), _uiKit.GridBreakpointsMediaDown.lg);
exports.ColumnLayoutLineStyled = ColumnLayoutLineStyled;
var ColumnLayoutItemWrapStyled = (0, _uiKit.styled)('div')(_templateObject5());
exports.ColumnLayoutItemWrapStyled = ColumnLayoutItemWrapStyled;
var ColumnLayoutTitleStyled = (0, _uiKit.styled)('h4')(_templateObject6(), _uiKit.GridBreakpointsMediaDown.lg);
exports.ColumnLayoutTitleStyled = ColumnLayoutTitleStyled;